"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PeriodDaysJSONModel = void 0;
const lodash_1 = __importDefault(require("lodash"));
const DEFAULT_TYPE = "last";
const DEFAULT_LAST_VALUE = 30;
const MAX_LAST_N_DAYS = 365 * 2; //2 years
class PeriodDaysJSONModel {
    constructor(serializedState) {
        this.reset = () => {
            this.resetType();
            this.resetLast();
        };
        this.overwriteFromSerializedState = (serializedState) => {
            if (serializedState) {
                this.setType(serializedState.type);
                this.setLast(serializedState.last);
            }
        };
        this.serialize = () => {
            return {
                type: this.type,
                last: this.getLast()
            };
        };
        ////////////////////////////////////////////////
        // Type
        ////////////////////////////////////////////////
        this.getType = () => this.type;
        this.setType = (value) => {
            switch (value) {
                case "last": {
                    this.type = value;
                    break;
                }
                default: {
                    this.resetType();
                    break;
                }
            }
        };
        this.resetType = () => {
            this.type = DEFAULT_TYPE;
        };
        ////////////////////////////////////////////////
        // Last
        ////////////////////////////////////////////////
        this.getLast = () => {
            if (this.last) {
                return this.last.value;
            }
            return DEFAULT_LAST_VALUE;
        };
        this.setLast = (value) => {
            const validatedValue = this.validateLast(value);
            if (lodash_1.default.isNil(validatedValue)) {
                this.resetLast();
            }
            else {
                this.last = {
                    value: validatedValue
                };
            }
        };
        this.resetLast = () => {
            this.last = {
                value: DEFAULT_LAST_VALUE
            };
        };
        this.reset();
        this.overwriteFromSerializedState(serializedState);
    }
    ////////////////////////////////////////////////
    // Validation
    ////////////////////////////////////////////////
    /**
     * @param value
     * @return `undefined` if invalid or `number` if valid
     */
    validateLast(value) {
        if (lodash_1.default.isNil(value)) {
            return undefined;
        }
        else {
            if (lodash_1.default.isString(value)) {
                value = lodash_1.default.toNumber(value);
            }
            if (!lodash_1.default.isFinite(value) || value < 1 || value > MAX_LAST_N_DAYS) {
                return undefined;
            }
            else {
                return value;
            }
        }
    }
}
exports.PeriodDaysJSONModel = PeriodDaysJSONModel;
